import React, { Component } from "react";
import close_btn from '../../../images/close_btn.svg';
import uploadIcon from '../../../images/upload.png';
import uploadSuccess from '../../../images/upload-success.png';
import { userService } from "../../../_services";
class AddEditTrainingVideo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userName: '',
            userId: '',
            videoTitle: '',
            fileTitle: '',
            videoLink: '',
            formError: '',
            formSuccess: '',
            isLoading: false,
            activeTab: "video", // "video" or "file"
            base64File: '',
            selectedFile: ''
        }
    }
    componentDidMount() {
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.setState({ userId: Usermeta_Data.split(':')[0], userName: Usermeta_Data.split(':')[1] })
        if (this.props.videoData) {
            this.setState({ videoTitle: this.props.videoData.mediaTitle, videoLink: this.props.videoData.mediaLink, })
        }
    }

    addMediaContents() {
        if (this.state.activeTab === "video") {
            this.addVideo();
        }
        else if (this.state.activeTab === "file") {
            this.addDocMediaFile();
        }
    }
    addVideo() {
        const YTregExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        if (this.state.videoTitle === '' || this.state.videoTitle == undefined || this.state.videoTitle.trim() === '') {
            this.setState({ formError: 'Please add title' })
            return false
        }
        else if (this.state.videoLink === '' || this.state.videoLink === undefined || this.state.videoLink.trim() === '') {
            this.setState({ formError: 'Please add link' })
            return false
        }
        else if (!this.state.videoLink.match(YTregExp)) {
            this.setState({ formError: 'Please enter valid youtube URL' })
            return false
        } else {
            let updatedUrl = this.state.videoLink
            if (this.state.videoLink.split('&').length > 1) {
                updatedUrl = this.state.videoLink.split('?')[0] + '?' + this.state.videoLink.split('?')[1].split('&').filter((item) => item.includes('v='))[0]
            }
            try {
                this.setState({ isLoading: true })
                if (this.props.mode === 'ADD') {
                    userService.AddMedia(this.state.userId, this.state.userName, this.props.moduleData.objectUID, this.state.videoTitle.trim(), updatedUrl).then((postdata) => {
                        if (postdata.length > 0) {
                            if (postdata[0].code === '1') {
                                this.setState({ formSuccess: postdata[0].message })
                                this.props.changeInVideo()
                            } else {
                                this.setState({ formError: postdata[0].message })
                            }
                            setTimeout(() => {
                                this.props.hideModal()
                            }, 2000)
                        }
                    })
                } else if (this.props.mode === 'EDIT') {
                    if (this.state.videoLink === '' || this.state.videoLink === undefined || this.state.videoLink.trim() === '') {
                        this.setState({ isLoading: false })
                        this.setState({ formError: 'Please add link' })
                    }
                    else {
                        userService.EditMedia(this.state.userId, this.state.userName, this.props.moduleData.objectUID, this.state.videoTitle, updatedUrl, this.props.videoData.mediaId).then((postdata) => {
                            if (postdata.length > 0) {
                                if (postdata[0].code === '1') {
                                    this.setState({ formSuccess: postdata[0].message })
                                    this.props.changeInVideo()
                                } else {
                                    this.setState({ formError: postdata[0].message })
                                }
                                setTimeout(() => {
                                    this.props.hideModal()
                                }, 2000)
                            }
                        })
                    }
                }
            } catch (err) {
                this.setState({ isLoading: false })
            }
        }
    }
    addDocMediaFile() {
        try {
            const fileInput = document.getElementById("file_upload");
            const { fileTitle, selectedFile } = this.state;

            if (!fileTitle || fileTitle.trim() === '') {
                this.setState({ formError: 'Please add title' });
                return;
            }

            if (!fileInput || fileInput.files.length === 0) {
                this.setState({ formError: "Please select a valid file." });
                return;
            }

            const file = fileInput.files[0];
            const fileType = file.type;
            const fileSize = file.size;

            const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
            if (!allowedTypes.includes(fileType)) {
                this.setState({ formError: "Invalid file type. Allowed types: jpg, jpeg, png, pdf." });
                return;
            }

            const maxSize = 5 * 1024 * 1024; // 5MB
            if (fileSize > maxSize) {
                this.setState({ formError: "File size exceeds the 5MB limit." });
                return;
            }

            this.setState({ isLoading: true });

            const formData = new FormData();
            formData.append("userId", this.state.userId);
            formData.append("userName", this.state.userName);
            formData.append("moduleid", this.props.moduleData.objectUID);
            formData.append("doctitle", fileTitle.trim());
            formData.append("file", file); // attach the raw file object
            formData.append("filetype", fileType);
            formData.append("mediaid", this.props.videoData.mediaId);
            let apiCall = this.props.mode === 'ADD' ?
                userService.AddDocFileMedia(formData) :
                userService.EditDocFileMedia(formData);

            apiCall.then(postdata => {
                if (postdata.length > 0) {
                    if (postdata[0].code === '1') {
                        this.setState({ formSuccess: postdata[0].message });
                        this.props.changeInVideo();
                    } else {
                        this.setState({ formError: postdata[0].message });
                    }
                    setTimeout(() => {
                        this.props.hideModal();
                    }, 2000);
                }
            }).catch(() => {
                this.setState({ formError: "Error uploading file." });
            }).finally(() => {
                this.setState({ isLoading: false });
            });
        } catch (err) {
            this.setState({ isLoading: false, formError: "Unexpected error occurred." });
        }
    }
    handleTabChange(tab) {
        this.setState({ activeTab: tab, formError: "", formSuccess: "", videoTitle: '', fileTitle: '', videoLink: '', selectedFile: '' });
    }

    handleFileChange(event) {
        this.setState({ selectedFile: event.target.files[0], formError: '' });
    }
    triggerFileInput = () => {
        document.getElementById('file_upload').click();
    }
    render() {
        return (
            <div className="training_modal add_training_video">
                <div className="modal_wrapper">
                    {/* Header */}
                    <div className="header">
                        <h3>
                            {this.props.mode === "EDIT" ? "Edit" : "Add"} {this.state.activeTab === "video" ? "Video" : "File"} in {this.props.moduleData.moduleName} Module
                        </h3>
                        <img src={close_btn} alt="Close" className="close-icon" onClick={this.props.hideModal} />
                    </div>

                    {/* Tabs */}
                    <div className="tab-container">
                        <button className={`tab-btn ${this.state.activeTab === "video" ? "active" : ""}`} onClick={() => this.handleTabChange("video")}>Video</button>
                        <button className={`tab-btn ${this.state.activeTab === "file" ? "active" : ""}`} onClick={() => this.handleTabChange("file")}>File</button>
                    </div>

                    {/* Modal Body */}
                    <div className="modal_body">
                        {this.state.activeTab === "video" ? (
                            <>
                                <div className="mat-input-wrapper">
                                    <input type="text" placeholder=" " id="title" name="training_video_title" className="mat-input" value={this.state.videoTitle} onChange={(e) => this.setState({ videoTitle: e.target.value, formError: '' })} />
                                    <label htmlFor="title" className="mat-label">Enter Video Title</label>
                                </div>
                                <div className="mat-input-wrapper">
                                    <input type="text" id="link" placeholder=" " name="training_video_link" className="mat-input" value={this.state.videoLink} onChange={(e) => this.setState({ videoLink: e.target.value, formError: '' })} />
                                    <label htmlFor="link" className="mat-label">Enter Video Link</label>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="mat-input-wrapper">
                                    <input type="text" placeholder=" " id="file_title" name="file_title" className="mat-input" value={this.state.fileTitle} onChange={(e) => this.setState({ fileTitle: e.target.value, formError: '' })} />
                                    <label htmlFor="file_title" className="mat-label">Enter Document Title</label>
                                </div>
                                <div className="file-upload-wrapper" onClick={this.triggerFileInput}>
                                <div className="upload-text">{this.state.selectedFile ? 'Uploaded' : 'Upload'} <img src={this.state.selectedFile ? uploadSuccess : uploadIcon} /></div>
                                <input type="file" id="file_upload" name="file_upload" className="file-input" accept="image/jpeg, image/png, application/pdf" onChange={this.handleFileChange.bind(this)} />
                            </div>
                            </>
                        )}

                    {/* Error and Success Messages */}
                    {this.state.formError ? <div className="error">{this.state.formError}</div> : null}
                    {this.state.formSuccess ? <div className="success_msgs">{this.state.formSuccess}</div> : null}
                </div>

                {/* Footer */}
                <div className="footer">
                    <button className={`btn red-btn ${this.state.isLoading ? "btn-loader" : ""}`} onClick={this.addMediaContents.bind(this)}>
                        {this.props.mode === "EDIT" ? "Update" : "Add"} {this.state.activeTab === "video" ? "Video" : "File"}
                    </button>
                    <button className="btn gray-btn" onClick={this.props.hideModal}>Cancel</button>
                </div>
            </div>
            </div >
        );
    }
}
export default AddEditTrainingVideo;